module.exports = __webpack_public_path__ + "static/media/2 (5).f99d777e.JPG";